module.exports = __webpack_public_path__ + "img/steps.7671fef0.png";